import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Main } from 'telia-front-react/main';
import { useStores } from "@stores/RootStore";

interface MainProps {
  children?: React.ReactChild | React.ReactChild[];
}

function MainWrapper(props: MainProps): React.ReactElement {
  const {
    cookieConsentStore,
    translateStore: { translateGlobal }
  } = useStores();

  const [rendered, setRendered] = useState<boolean>(false);

  const consentContent = {
    title: translateGlobal('cookieagreement.notice.title'),
    description: translateGlobal('cookieagreement.notice.description'),
    button: {
      text: translateGlobal('cookieagreement.notice.button'),
      onClick: () => window.Cookiebot.show()
    },
    categories: {
      statistics: translateGlobal('cookieagreement.statistics'),
      necessary: translateGlobal('cookieagreement.necessary'),
      marketing: translateGlobal('cookieagreement.marketing'),
      preferences: translateGlobal('cookieagreement.preferences')
    }
  };

  useEffect(() => {
    setRendered(true);
  }, []);

  if (!rendered) {
    return (
      <Main consentContent={consentContent} consentEnabled={true} consent={cookieConsentStore?.cookieConsents}>
        {props.children}
      </Main>
    );
  }

  return (
    <Main consentContent={consentContent} consentEnabled={cookieConsentStore?.isCookiebotEnabled} consent={cookieConsentStore?.cookieConsents}>
      {props.children}
    </Main>
  );
}

export default observer(MainWrapper);
